import { axios } from '@/utils/request'

export const serviceInfo = () => {
  return axios.get('/api/web/biz/service/exist')
}
